import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'mnc-activitycenter-samples',
  imports: [
    RouterModule,
  ],
  template: '<router-outlet></router-outlet>'
})
export class SamplesComponent {
}
